import script from "./DocItemTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemTable.vue?vue&type=script&setup=true&lang=js"

import "./DocItemTable.vue?vue&type=style&index=0&id=62e9bfd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e9bfd2"]])

export default __exports__